// extracted by mini-css-extract-plugin
export default {"container_body":"Calendar_container_body__12ZVO","events_container":"Calendar_events_container__h-wRX","react_calendar":"Calendar_react_calendar__VvyUw"};